/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const ActivityChart = ({ data, period }) => (
  <div className="bg-slate-900 p-4 sm:p-5 rounded-2xl border border-slate-800 shadow-sm text-white">
    <div className="mb-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-bold text-sm sm:text-base">
            Booking Activity
          </h3>
          <p className="text-xs text-white/60">Current period</p>
        </div>
        <span className="text-xs px-2 py-1 bg-blue-500/20 text-blue-300 rounded border border-blue-500/30">
          Time-filtered
        </span>
      </div>
    </div>
    <div className="h-48 sm:h-56">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#475569"
          />
          <XAxis dataKey="name" fontSize={12} stroke="#94a3b8" />
          <YAxis fontSize={12} stroke="#94a3b8" />
          <Tooltip
            contentStyle={{
              backgroundColor: "#1e293b",
              border: "1px solid #475569",
              borderRadius: "8px",
              color: "#fff",
            }}
          />
          <Legend
            wrapperStyle={{
              fontSize: "12px",
              paddingTop: "10px",
              color: "#fff",
            }}
          />
          <Bar
            dataKey="bookings"
            name="Total"
            fill="#CE257A"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="completed"
            name="Completed"
            fill="#10b981"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="workStarted"
            name="Work Started"
            fill="#f59e0b"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="cancelled"
            name="Cancelled"
            fill="#ef4444"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default ActivityChart;
